export type FallbackFileName = keyof typeof FallbackFiles;
export const getFallbackFile = (name: FallbackFileName): object | undefined => {
  return FallbackFiles[name];
};

const FallbackFiles = {
  accountMenu: require('./accountMenu.json'),
} as const;
